/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useRef } from 'react'

const useEnterKey = (callback?: () => void) => {
  const enterKeyRefClick = useRef(null)

  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault()
        // @ts-ignore
        enterKeyRefClick.current.click()
        callback && callback()
      }
    }
    document.addEventListener('keydown', listener)

    return () => document.removeEventListener('keydown', listener, false)
  }, [])

  return [enterKeyRefClick]
}

export default useEnterKey
